import React from 'react'
import { Row, Col } from 'react-bootstrap'

const Search = ({
  setSearchText,
  setCurrentPage,
  handleOnChange,
  searchText,
  roundDate,
  clearSearch,
  fetchLotteries,
  digitsSearchType,
  status,
  currentPage,
}) => {
  const onSearch = () => {
    if (currentPage !== 1) {
      setCurrentPage(1)
    } else {
      fetchLotteries(currentPage, searchText, status, digitsSearchType, roundDate)
    }
  }

  const handleOnChangeSearchText = (e) => {
    const { value } = e.target
    setSearchText(value)
  }

  return (
    <Row sm={12}>
      <Col sm={12} md={6} lg={6}>
        <div className="d-flex">
          <input
            type="text"
            placeholder="เลขที่ต้องการ"
            value={searchText}
            maxLength={6}
            className="form-control mr-2"
            style={{ color: '#5d5d5d' }}
            onChange={handleOnChangeSearchText}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && searchText.length === 6) {
                handleOnChange(e)
              }
            }}
          />
        </div>
        {searchText.length < 6 && <label style={{ color: 'red', fontSize: 12 }}>กรุณากรอกเลขให้ครบ 6 หลัก</label>}
      </Col>
      <button
        type="button"
        className="btn btn-primary light align-self-start "
        style={{ minWidth: '120px' }}
        disabled={searchText.length < 6}
        onClick={() => onSearch()}
      >
        ค้นหา
      </button>
      <div
        type="button"
        className="btn btn-primary light align-self-start"
        style={{ minWidth: '120px', marginLeft: '10px' }}
        onClick={() => clearSearch()}
      >
        ล้างการค้นหา
      </div>
    </Row>
  )
}

export default Search
